export default __webpack_public_path__ + "static/media/landingVideo.75e9d361.mp4";